// extracted by mini-css-extract-plugin
var _1 = "NameEdit_field__rC9xs";
var _2 = "NameEdit_wrapper__J5D+l";
export { _1 as "field", _2 as "wrapper" }
